import React from "react";
import * as styles from "./style.css";
import { clsx } from "uikit/utils";

type ContainerProps = {
  background: "primary" | "secondary";
  margin?: "md" | "lg";
} & React.PropsWithChildren &
  React.HTMLAttributes<HTMLDivElement>;

const Container = ({
  background,
  children,
  margin,
  className,
  ...props
}: ContainerProps) => {
  return (
    <div
      className={clsx(styles.container({ background, margin }), className)}
      {...props}
    >
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default Container;
